import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ProductCustomizerRoutingModule } from './product-customizer-routing.module';
import { ProductCustomizerComponent } from './product-customizer.component';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { FormsModule } from '@angular/forms';
import { CustomFlexLayoutModule } from '../flex-layout/custom-flex-layout.module';





@NgModule({
  declarations: [
    ProductCustomizerComponent
  ],
  imports: [
    CommonModule,
    ProductCustomizerRoutingModule,
    DragDropModule,
    // ContextMenuModule,
    FormsModule,
    CustomFlexLayoutModule,
    
  ],
  exports:[ProductCustomizerComponent]
})
export class ProductCustomizerModule { }
